import { GlobalDataProvider } from './context/GlobalDataContext';
import { GlobalDataLayout } from './components/GlobalDataLayout';

export const GlobalData = () => {
    return (
        <GlobalDataProvider>
            <GlobalDataLayout />
        </GlobalDataProvider>
    );
};
